module.exports = __webpack_public_path__ + "img/40.e93e736d.png";